import React, { Component } from "react";

import { connect } from "react-redux";
import { server } from "redux-server-connection";
import urls from "../../reducers/urls";

import Render from "./Render";

class DesafiosConsigna extends Component {
  componentWillMount() {
    if (typeof window !== "undefined" && !this.props.trivia) {
      this.props.getTrivia();
    }
  }

  render() {
    return <Render {...this.props} />;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    trivia: state.trivias.elements[ownProps.match.params.id]
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getTrivia: () =>
      dispatch(
        server.get(
          urls.trivias.single(ownProps.match.params.id),
          "ELEMENT_TRIVIAS"
        )
      )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DesafiosConsigna);



// WEBPACK FOOTER //
// ./src/pages/TriviasConsigna/index.js